import React, { useState } from 'react';
import { usePopper } from 'react-popper';
import {
  popperGenerator,
  Options,
  offset,
  flip,
  popperOffsets,
  eventListeners,
  computeStyles,
  applyStyles,
  preventOverflow,
} from '@popperjs/core';
import { useResizeDetector } from 'react-resize-detector';
import useForkRef from './useForkRef';

const createPopper = popperGenerator({
  defaultModifiers: [
    preventOverflow,
    popperOffsets,
    eventListeners,
    computeStyles,
    applyStyles,
    {
      ...offset,
      options: {
        offset: [0, 6],
      },
    },
    {
      ...flip,
      options: {
        fallbackPlacements: ['bottom-end', 'top-start', 'top-end'],
      },
    },
  ],
});

/**
 * @deprecated Since version 3.1.0. Use useAutoPosition instead
 */
const useAutoPositioner = (options: Partial<Options> = {}) => {
  const [popperReferenceElement, setPopperReferenceElement] = useState<
    HTMLElement | null | undefined
  >();
  const [popperElement, setPopperElement] = useState<
    HTMLElement | null | undefined
  >();

  const { styles, attributes, update } = usePopper(
    popperReferenceElement,
    popperElement,
    {
      placement: 'bottom-start',
      ...options,
      createPopper,
    },
  );

  const onResize = () => {
    if (update) {
      update();
    }
  };

  const { ref: resizeRef } = useResizeDetector({
    onResize,
    refreshRate: 100,
    refreshMode: 'debounce',
  });

  const setReferenceElement = useForkRef([
    setPopperReferenceElement,
    resizeRef,
  ]);

  return {
    setReferenceElement: setReferenceElement as React.RefCallback<HTMLElement>,
    setPopperElement: setPopperElement as React.RefCallback<HTMLElement>,
    styles,
    attributes,
  };
};

export default useAutoPositioner;
